import getSubscribedPaths from "./getSubscribedPaths";
import type { UnsubsByPath } from "./types";

export default function getMissingDefinitions<
  PathDefinition extends { onlyOnce?: boolean },
>(
  unsubsByPath: UnsubsByPath,
  newDefinitions: PathDefinition[],
  definitionToPath: (definition: Omit<PathDefinition, "onlyOnce">) => string,
) {
  const existingPaths = new Set(getSubscribedPaths(unsubsByPath));

  const missingDefinitions = newDefinitions.filter((newDefinition) => {
    if (newDefinition.onlyOnce) {
      return true;
    }

    const newPath = definitionToPath(newDefinition);

    return !existingPaths.has(newPath);
  });

  return missingDefinitions;
}
